import { Stamp } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-secondary/50">
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-sm bg-primary text-primary-foreground">
                <Stamp className="h-4.5 w-4.5" aria-hidden="true" />
              </span>
              <span className="font-display text-base font-semibold text-primary">
                Carolina Mountain Stamps
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-muted-foreground">
              U.S. and world stamps, covers, and supplies — from Hendersonville, North Carolina.
            </p>
          </div>

          <nav aria-label="Footer">
            <h2 className="text-xs font-semibold uppercase tracking-[0.22em] text-muted-foreground">
              Explore
            </h2>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="/#collections" className="hover:text-accent">
                  Collections
                </a>
              </li>
              <li>
                <a href="/#about" className="hover:text-accent">
                  About
                </a>
              </li>
              <li>
                <a href="/blog" className="hover:text-accent">
                  Blog
                </a>
              </li>
              <li>
                <a href="/#locations" className="hover:text-accent">
                  Visit
                </a>
              </li>
              <li>
                <a href="/#want-list" className="hover:text-accent">
                  Want list
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.22em] text-muted-foreground">
              Contact
            </h2>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="mailto:saca@ix.netcom.com" className="hover:text-accent">
                  saca@ix.netcom.com
                </a>
              </li>
              <li>
                <a href="tel:+18646162403" className="hover:text-accent">
                  (864) 616-2403
                </a>
              </li>
              <li>Hendersonville, NC</li>
              <li>
                <a
                  href="https://www.ebay.com/str/carolinamountainstamps"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="hover:text-accent"
                >
                  eBay store
                  <span className="sr-only"> (opens in a new tab)</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-xs text-muted-foreground md:flex-row">
          <p>© {new Date().getFullYear()} Carolina Mountain Stamps. All rights reserved.</p>
          <p>Sally Campbell · cmstamps.com</p>
        </div>
      </div>
    </footer>
  );
}
